import { isProduction } from "common/utils/env";
import { EventBus, Events } from "jiffy-store";
import "./product-mosaic.scss";

const ROOT_SELECTOR = ".js-product-mosaic";
const MOSAIC_IMAGE_SELECTOR = ".mosaic-image";
const ERROR_REPORT_ENDPOINT = "/api/error_reports/mosaic_image";

const $getMosaics = () => document.querySelectorAll(ROOT_SELECTOR);
const $getMosaicImage = $mosaic => $mosaic.querySelector(MOSAIC_IMAGE_SELECTOR);
const $getMosaicFromElement = $element => $element?.closest?.(ROOT_SELECTOR);

function handleMosaicClick(e) {
  e.stopPropagation();
  e.preventDefault();

  EventBus.publish(Events.TOGGLE_PRODUCT_COLOR_PICKER, e.currentTarget);
}

const keydownCallback = e => {
  if (e.keyCode === 13 || e.keyCode === 32) {
    handleMosaicClick(e);
  }
};

const handleMosaicImageError = e => {
  const imageSrc = e.target?.src || "unknown";
  const $mosaic = $getMosaicFromElement(e.target);
  const productId = $mosaic?.dataset?.productId || null;

  if (!isProduction() || !productId) return;

  fetch(ERROR_REPORT_ENDPOINT, {
    method: "POST",
    headers: { "Content-Type": "application/json" },
    body: JSON.stringify({ product_id: productId, image_src: imageSrc })
  }).catch(() => {});
};

export default () => {
  const $elMosaics = $getMosaics();

  $elMosaics.forEach($mosaic => {
    const $mosaicImage = $getMosaicImage($mosaic);

    $mosaic.addEventListener("click", handleMosaicClick);
    $mosaic.addEventListener("keydown", keydownCallback);
    if ($mosaicImage) {
      $mosaicImage.onerror = handleMosaicImageError;
    }
  });

  return () => {
    $elMosaics.forEach($mosaic => {
      const $mosaicImage = $getMosaicImage($mosaic);
      $mosaic.removeEventListener("click", handleMosaicClick);
      $mosaic.removeEventListener("keydown", keydownCallback);
      if ($mosaicImage) {
        $mosaicImage.onerror = null;
      }
    });
  };
};
